import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
  OrgProductsWithPrices,
  ProductSalePriceInfo,
  RemoveProductSalePrices,
  SaveProductSalePrices,
} from "../schemas/index.js";

const c = initContract();

export const salePricesContract = c.router({
  saveProductSalePrices: {
    method: "POST",
    path: "/trade-sales/product/sale-prices/save",
    responses: {
      [200]: z.object({ status: z.literal("success") }),
    },
    body: SaveProductSalePrices,
    summary:
      "Saves an array of sale prices for an organisation, optionally scoped to a specific nominated purchaser.",
  },
  getProductSalePrices: {
    method: "GET",
    path: "/trade-sales/product/sale-prices",
    query: z.object({
      organisationId: z.string(),
      purchaserId: z.string().nullable(),
      productIds: z.coerce
        .string()
        .default("[]")
        .transform((v) => (v ? JSON.parse(v) : [])),
    }),
    responses: {
      [200]: ProductSalePriceInfo.array(),
    },
    summary:
      "Gets all the saved sale product sale prices for an organisation, with the default prices overriden if a nominated purchaser scoped one exists.",
  },
  getPurchaserProductSalePrices: {
    method: "GET",
    path: "/trade-sales/product/sale-prices/purchaser",
    query: z.object({
      organisationId: z.string(),
      purchaserId: z.string(),
    }),
    responses: {
      [200]: ProductSalePriceInfo.array(),
    },
    summary:
      "Gets all the saved product sale prices for an organisation, scoped only to a nominated purchaser.",
  },
  removeProductSalePrices: {
    method: "DELETE",
    path: "/trade-sales/product/sale-prices",
    body: RemoveProductSalePrices,
    responses: {
      [200]: z.object({ status: z.literal("success") }),
    },
    summary: "Removes a product sale price from the database",
  },

  getProductsWithPricesByOrgId: {
    method: "GET",
    path: "/trade-sales/product/products-with-sale-prices",
    query: z.object({
      organisationId: z.string(),
    }),
    responses: {
      [200]: OrgProductsWithPrices,
    },
    summary:
      "Gets the ids of all products for an organisation, where they have set a default price.",
  },
});
